module.exports = __webpack_public_path__ + "img/pic_earncoins_offer@3x.c0f39e3c.png";